import React from 'react';

import api from '../utils/Api';

import './ResendVerification.scss';

interface ResendVerificationProps {
  email: string;
}

/** A "Send the link again" button for an account whose email isn't confirmed yet. */
const ResendVerification = ({ email }: ResendVerificationProps) => {
  const [state, setState] = React.useState<'idle' | 'sending' | 'sent'>('idle');
  const [error, setError] = React.useState('');

  const resend = () => {
    setState('sending');
    setError('');
    api
      .auth('resend-verification', 'POST', { email })
      .then(() => setState('sent'))
      .catch(err => {
        setState('idle');
        setError(err.message);
      });
  };

  return (
    <div className="resend-verification">
      {state === 'sent' ? (
        <p>A new link is on its way. Check your inbox and spam folder.</p>
      ) : (
        <button type="button" className="resend-verification-button" onClick={resend} disabled={state === 'sending'}>
          {state === 'sending' ? 'Sending...' : 'Send the link again'}
        </button>
      )}
      {error && <p className="resend-verification-error">{error}</p>}
    </div>
  );
};

export default ResendVerification;
